import { handleAuthorization, handleOkResponseJson, handleBadRequest400 } from "./handlers"
import { obterToken } from "./loginService"
import { normalizeTextUppercase } from "../utils"

export const obterServicosPlanoAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/ServicoPlano/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const obterServicosPlanoPorPeriodicidadeAsync = async (idPlano, idPeriodicidade) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/ServicoPlano/obterListaPorPeriodicidade/` + idPlano + `,` + idPeriodicidade, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarServicoPlanoAsync = async (descricao, itemTroca) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ descricao: normalizeTextUppercase(descricao), itemTroca })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/ServicoPlano`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}

export const editarServicoPlanoAsync = async (id, descricao, itemTroca, ativo) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, descricao: normalizeTextUppercase(descricao), itemTroca, ativo })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/ServicoPlano/atualizar`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}
